// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DONE = "Hotovo";
export const WIKI_ARTICLE_AMBASSADOR_BRAND_CLEAR_CONFIRM = "Jsi si jist\u00e1, \u017ee chce\u0161 od \u010dl\u00e1nku odpojit tvou ambasadorskou zna\u010dku?";
export const WIKI_ARTICLE_AMBASSADOR_BRAND_SET_CONFIRM = "Jsi si jist\u00e1, \u017ee chce\u0161 k \u010dl\u00e1nku p\u0159ipojit tvou ambasadorskou zna\u010dku?";
